/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';
import { I18nService } from '@dm/core';

@Component({
    selector: 'app-error-other',
    templateUrl: './error-other.component.html',
    styleUrls: ['./error-other.component.scss'],
})

export class ErrorOtherComponent {
    constructor(
        public i18n: I18nService,
    ) { }
}
